import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h1 d-none d-md-block mb-4" }, "Crop Your Photo", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 ms-auto me-auto" }, "pinch-and-zoom to resize your photo", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ModalBase, {
    title: "Crop Photo",
    size: "modal-fullscreen-sm-down",
    ref: "modal"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.isUserPhoto)
          ? (_openBlock(), _createBlock(_component_cropper, {
              key: 0,
              ref: "cropperRef",
              class: "",
              src: _ctx.image.src,
              "stencil-props": {
                  handlers: {},
                  movable: false,
                  resizable: false,
                },
              "stencil-size": {
                   width: 200,
                   height: 200
                 },
              "image-restriction": "stencil"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (!_ctx.isUserPhoto)
          ? (_openBlock(), _createBlock(_component_cropper, {
              key: 1,
              ref: "cropperEntityRef",
              class: "",
              src: _ctx.image.src,
              "stencil-props": {
                    handlers: {},
                    movable: false,
                    resizable: false,
                  },
              "stencil-size": {
                   width: 500,
                   height: 250
                 },
              "image-restriction": "stencil"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        _hoisted_3,
        _createVNode(_component_Button, {
          class: "mt-4",
          onClick: _ctx.saveImage
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save Photo")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "mt-4",
          type: "secondary",
          onClick: _ctx.toggleClosed
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.isLoading]
  ])
}